const getApiUrls = () => {
    const environment = process.env.REACT_APP_ENVIRONMENT || 'dev';

    const configs = {
        dev: {
            servicesHosts: {
                infrastructureService: "http://sentryti-dev-1918717728.us-east-1.elb.amazonaws.com/infrastructure/api/v1",
                dataService: "http://sentryti-dev-1918717728.us-east-1.elb.amazonaws.com/data/api/v1",
                authenticationService: "http://sentryti-dev-1918717728.us-east-1.elb.amazonaws.com/auth",
                notificationService: "http://sentryti-dev-1918717728.us-east-1.elb.amazonaws.com/notification/api/v1",
            }
        },
        prod: {
            servicesHosts: {
                infrastructureService: "https://dashboard.sentryti.com/infrastructure/api/v1",
                dataService: "https://dashboard.sentryti.com/data/api/v1",
                authenticationService: "https://dashboard.sentryti.com/auth",
                notificationService: "https://dashboard.sentryti.com/notification/api/v1",
            }
        }
    };

    return configs[environment] || configs.dev;
};

const config = {
    ...getApiUrls(),
    uiSettings: {
        itemsPerPage: 20,
        refreshTimeOfRequest: 10000
    }
};

export default config;